module.exports = __webpack_public_path__ + "img/vip_tp_bg.0c259df7.png";